//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { FilterGroupModel } from '@shared/components/filter';
import { PresenterType } from '@shared/components/presenter';

@PresenterType(
{
    model: FilterGroupModel
})
@Component({
    selector: 'filter-group-template',
    templateUrl: './filter-group-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilterGroupTemplateComponent
{
    public data: WritableSignal<FilterGroupModel>;
    
    constructor() {
        this.data = signal<FilterGroupModel>(null);
    }
}